import { getStorage } from '@src/utils/enhancedStorage'

import { LOCAL_STORAGE_KEYS } from './constants'
import isBrowser from './isBrowser'

export const setJoinWaitlistPhoneNumber = (phoneNumber: string): void => {
  if (!isBrowser()) return
  getStorage().setItem(LOCAL_STORAGE_KEYS.WAITLIST.JOIN_PHONE, phoneNumber, { isGlobal: true })
}

export const getJoinWaitlistPhoneNumber = (): string | null => {
  if (!isBrowser()) return null
  return getStorage().getItem<string>(LOCAL_STORAGE_KEYS.WAITLIST.JOIN_PHONE, { isGlobal: true }) ?? null
}

export const removeJoinWaitlistPhoneNumber = (): void => {
  if (!isBrowser()) return
  getStorage().removeItem(LOCAL_STORAGE_KEYS.WAITLIST.JOIN_PHONE, { isGlobal: true })
}

export const hydrateWaitlistPhoneFromMeta = (customerMetadata: { phoneNumber?: unknown } | undefined): void => {
  const phoneNumber = customerMetadata?.phoneNumber
  if (typeof phoneNumber !== 'string' || phoneNumber.length === 0) return
  setJoinWaitlistPhoneNumber(phoneNumber)
}
